module.exports = __webpack_public_path__ + "img/report-sample-15@3x.49a6355a.png";